'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.MarketAnalysis.Helpers', dependencies).service('SelectedMarketHelperService', require('./services/SelectedMarketHelperService'));